import gql from 'graphql-tag';
export const smallOverlay = gql `
  fragment SmallOverlay on Overlay {
    matchId
    id
    encodingDelay
    autoMode
    enableAds
    resolution
    showWatermarks
    background
    backgroundColor
    manualGraphicState
    enableAds
    key
  }
`;
//# sourceMappingURL=overlay.js.map